export { default } from "./DetailRow";
